import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../Css/GestionUtilisateur.css';

const GestionUtilisateur = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('');
  const [users, setUsers] = useState([]);
  const [editingUser, setEditingUser] = useState(null);  // To track the user being edited
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();


  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem('token'); 

  useEffect(() => {
    // Fetch users when the component mounts
    const fetchUsers = async () => {
      try {
        const response = await fetch(`${apiUrl}/api/users`, {
            headers: { 'Authorization': `Bearer ${token}` },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setUsers(data); // Set users in state
      } catch (error) {
        console.error('API Error:', error);
        alert('Error fetching users: ' + error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [apiUrl]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${apiUrl}/api/signup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ username, password, role }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      setUsername('');
      setPassword('');
      setRole('');

      alert('User created successfully');

      const updatedUsers = await fetch(`${apiUrl}/api/users`, {
        headers: { 'Authorization': `Bearer ${token}` },
      }).then(res => res.json());

      setUsers(updatedUsers);
    } catch (error) {
      console.error('API Error:', error);
      alert('Error during sign up: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleRoleChange = (e) => {
    const role = e.target.value;
    setRole(role);
  };

  // Handle deleting a user
  const handleDelete = async (userId) => {
    const confirmed = window.confirm("Are you sure you want to delete this user?");
    if (!confirmed) return;

    try {
      const response = await fetch(`${apiUrl}/api/users/${userId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      setUsers(users.filter(user => user.id !== userId));
      alert('User deleted successfully');
    } catch (error) {
      console.error('API Error:', error);
      alert('Error deleting user: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  // Start editing a user
  const handleModify = (user) => {
    window.scrollTo(0, 0); // Scroll to the top of the page
    setEditingUser(user);
    setUsername(user.username);
    setPassword(''); // Typically you wouldn't populate password during edit
    setRole(user.role);
  };

  // Update the user after editing
  const handleUpdate = async (e) => {
    e.preventDefault();

    if (!username || !role) {
      alert("Username and Role are required.");
      return;
    }

    try {
      const response = await fetch(`${apiUrl}/api/users/${editingUser.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ username, password, role }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      // Update the user in the state
      setUsers(users.map(user => (user.id === editingUser.id ? { ...user, username, role } : user)));
      alert('User updated successfully');

      // Clear form and exit edit mode
      setEditingUser(null);
      setUsername('');
      setPassword('');
      setRole('');
    } catch (error) {
      console.error('API Error:', error);
      alert('Error updating user: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  // Cancel editing
  const handleCancel = () => {
    setEditingUser(null);
    setUsername('');
    setPassword('');
    setRole('');
  };


  if (loading) {
    return <div className='loader'>
        <span style={{ '--i': 1 }}>L</span>
        <span style={{ '--i': 2 }}>o</span>
        <span style={{ '--i': 3 }}>a</span>
        <span style={{ '--i': 4 }}>d</span>
        <span style={{ '--i': 5 }}>i</span>
        <span style={{ '--i': 6 }}>n</span>
        <span style={{ '--i': 7 }}>g</span>
        <span style={{ '--i': 8 }}>.</span>
        <span style={{ '--i': 9 }}>.</span>
        <span style={{ '--i': 10 }}>.</span>
      </div>;
  }

  if (error) {
    return <div className='Error-API'>Error: {error}</div>;
  }

  return (
    <div className="signup__container">
      <form className="signup__form" onSubmit={editingUser ? handleUpdate : handleSubmit}>
        <h2 className="Facturetablie__title">{editingUser ? 'Éditer les informations utilisateur' : 'Gestion des accès utilisateurs'}</h2>

        <input
          className="signup__input"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Nom d'utilisateur"
          required
        />
        <input
          className="signup__input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Mot de passe (ne pas remplir si non modifié)"
        />
        <select
          className="signup__select"
          value={role}
          onChange={handleRoleChange}
          required
        >
          <option value="" disabled>Choisissez un rôle</option>
          <option value="User-facturation">Utilisateur de facturation</option>
          <option value="User-reservation">Utilisateur de réservation</option>
          <option value="admin">Administrateur</option>
        </select>

        {editingUser ? (
          <>
            <button className="signup__button" type="submit">Update</button>
            <button className="signup__button" type="button" onClick={handleCancel}>Cancel</button>
          </>
        ) : (
          <button className="signup__button" type="submit">Submit</button>
        )}
      </form>

      <table className="user-table">
        <thead>
          <tr>
            <th>Nom d'utilisateur</th>
            <th>Rôle</th>
            <th style={{textAlign: 'center'}}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <tr key={user.id}>
              <td>{user.username}</td>
              <td>{user.role}</td>
              <td className='user-block-button'>
                <button className="modify-btn" onClick={() => handleModify(user)}>Éditer</button>
                <button className="delete-btn" onClick={() => handleDelete(user.id)}>Supprimer</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default GestionUtilisateur;

